/* Saieno Studio OS2 - tiny theme JS (no dependencies) */
(function(){
  function $(sel, root){ return (root||document).querySelector(sel); }
  function $all(sel, root){ return Array.from((root||document).querySelectorAll(sel)); }

  var _mediaGalleryBound = false;

  function openMediaModal(gallery){
    var modal = gallery.querySelector('[data-media-modal]');
    if(!modal) return;

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('saieno-modal-open');
  }

  function closeMediaModal(gallery){
    var modal = gallery.querySelector('[data-media-modal]');
    if(!modal) return;

    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('saieno-modal-open');
  }

  function setModalIndex(gallery, idx){
    var modal = gallery.querySelector('[data-media-modal]');
    if(!modal) return;

    var thumbs = $all('[data-modal-thumb]', modal);
    if(!thumbs.length) return;

    // wrap
    if(idx < 0) idx = thumbs.length - 1;
    if(idx >= thumbs.length) idx = 0;

    modal.dataset.index = String(idx);

    var btn = thumbs[idx];
    var main = modal.querySelector('[data-modal-main-media]');
    if(!btn || !main) return;

    var full = btn.getAttribute('data-full');
    var alt  = btn.getAttribute('data-alt');

    if(full){
      main.classList.add('is-swapping');
      var done = function(){ main.classList.remove('is-swapping'); };
      main.addEventListener('load', done, { once: true });
      setTimeout(done, 800);

      main.setAttribute('src', full);
      if(main.hasAttribute('srcset')) main.removeAttribute('srcset');
      if(main.hasAttribute('sizes'))  main.removeAttribute('sizes');
    }
    if(alt) main.setAttribute('alt', alt);

    thumbs.forEach(function(b){ b.classList.remove('is-active'); });
    btn.classList.add('is-active');

    // keep selected thumb in view
    try { btn.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch(e){}
  }

  function getModalIndex(gallery){
    var modal = gallery.querySelector('[data-media-modal]');
    if(!modal) return 0;
    var n = parseInt(modal.dataset.index || '0', 10);
    return isNaN(n) ? 0 : n;
  }

  var _mediaGalleryBound = false;

  function initMediaGalleries(){
    if (_mediaGalleryBound) return;
    _mediaGalleryBound = true;

    document.addEventListener('click', function(e){
      // Close modal
      var closeBtn = e.target && e.target.closest ? e.target.closest('[data-media-modal-close]') : null;
      if(closeBtn){
        var gClose = closeBtn.closest('[data-media-gallery]');
        if(gClose) closeMediaModal(gClose);
        return;
      }

      // Open modal via +N button
      var moreBtn = e.target && e.target.closest ? e.target.closest('[data-media-more]') : null;
      if(moreBtn){
        var gMore = moreBtn.closest('[data-media-gallery]');
        if(gMore){
          openMediaModal(gMore);
          setModalIndex(gMore, 0);
          e.preventDefault();
        }
        return;
      }

      var navBtn = e.target && e.target.closest ? e.target.closest('[data-modal-nav]') : null;
      if(navBtn){
        var gallery3 = navBtn.closest('[data-media-gallery]');
        if(!gallery3) return;

        var modal3 = gallery3.querySelector('[data-media-modal]');
        if(!modal3 || modal3.hidden) return;

        e.preventDefault();

        var dir = navBtn.getAttribute('data-modal-nav');
        var idx3 = getModalIndex(gallery3);
        setModalIndex(gallery3, dir === 'prev' ? (idx3 - 1) : (idx3 + 1));
        return;
      }

      // Swap main image (inline thumbs)
      var btn = e.target && e.target.closest ? e.target.closest('[data-media-thumb]') : null;
      if(btn){
        var gallery = btn.closest('[data-media-gallery]');
        if(!gallery) return;

        var main = gallery.querySelector('[data-main-media]');
        if(!main) return;

        e.preventDefault();

        var full = btn.getAttribute('data-full');
        var alt  = btn.getAttribute('data-alt');

        if(full){
          main.classList.add('is-swapping');
          var done = function(){ main.classList.remove('is-swapping'); };
          main.addEventListener('load', done, { once: true });
          setTimeout(done, 800);

          main.setAttribute('src', full);
          if(main.hasAttribute('srcset')) main.removeAttribute('srcset');
          if(main.hasAttribute('sizes'))  main.removeAttribute('sizes');
        }
        if(alt) main.setAttribute('alt', alt);

        $all('[data-media-thumb]', gallery).forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        return;
      }

      // Swap modal main image (modal thumbs)
      var mbtn = e.target && e.target.closest ? e.target.closest('[data-modal-thumb]') : null;
      if(mbtn){
        var gallery2 = mbtn.closest('[data-media-gallery]');
        if(!gallery2) return;

        var modal = gallery2.querySelector('[data-media-modal]');
        if(!modal || modal.hidden) return;

        var main2 = modal.querySelector('[data-modal-main-media]');
        if(!main2) return;

        e.preventDefault();

        var full2 = mbtn.getAttribute('data-full');
        var alt2  = mbtn.getAttribute('data-alt');

        if(full2){
          main2.classList.add('is-swapping');
          var done2 = function(){ main2.classList.remove('is-swapping'); };
          main2.addEventListener('load', done2, { once: true });
          setTimeout(done2, 800);

          main2.setAttribute('src', full2);
          if(main2.hasAttribute('srcset')) main2.removeAttribute('srcset');
          if(main2.hasAttribute('sizes'))  main2.removeAttribute('sizes');
        }
        if(alt2) main2.setAttribute('alt', alt2);

        $all('[data-modal-thumb]', modal).forEach(function(b){ b.classList.remove('is-active'); });
        mbtn.classList.add('is-active');
        return;
      }
    });

    // ESC to close any open modal
    document.addEventListener('keydown', function(e){
      if(e.key !== 'Escape') return;
      $all('[data-media-modal]').forEach(function(modal){
        if(modal.hidden) return;
        var g = modal.closest('[data-media-gallery]');
        if(g) closeMediaModal(g);
      });
      if(e.key === 'ArrowLeft' || e.key === 'ArrowRight'){
        var openModal = $all('[data-media-modal]').find(function(m){ return !m.hidden; });
        if(!openModal) return;

        var g = openModal.closest('[data-media-gallery]');
        if(!g) return;

        var idx = getModalIndex(g);
        setModalIndex(g, e.key === 'ArrowLeft' ? (idx - 1) : (idx + 1));
      }
    });
  }

  // Variant picker: updates hidden input + price/availability if present
  function initVariantForms(){
    $all('[data-product-form]').forEach(function(form){
      var variantsJsonEl = form.querySelector('[data-variants-json]');
      if(!variantsJsonEl) return;

      var variants = [];
      try { variants = JSON.parse(variantsJsonEl.textContent || '[]'); } catch(e){ variants = []; }

      var optionSelects = $all('select[data-option-index]', form);
      var idInput = form.querySelector('input[name="id"]');

      // price/compare elements are outside the <form> in this theme
      var root = form.closest('[data-product-root]') || form.closest('section') || form.parentElement;
      var priceEl = root ? root.querySelector('[data-price]') : null;
      var compareWrap = root ? root.querySelector('[data-compare]') : null;
      var compareEl = compareWrap ? (compareWrap.querySelector('s') || compareWrap) : null;

      var addBtn = form.querySelector('button[type="submit"]');


      function findVariant(){
        var selected = optionSelects.map(function(s){ return s.value; });
        return variants.find(function(v){
          if(!v || !v.options) return false;
          for(var i=0;i<selected.length;i++){
            if(v.options[i] !== selected[i]) return false;
          }
          return true;
        }) || variants.find(function(v){ return v && v.available; }) || variants[0];
      }

      function formatMoney(cents){
        // naive formatter - Shopify will localize in Liquid elsewhere; this is just for live update
        var n = (cents||0) / 100;
        return n.toLocaleString(undefined, { style:'currency', currency: document.documentElement.getAttribute('data-currency') || 'USD' });
      }

      function applyVariant(v){
        if(!v) return;
        if(idInput) idInput.value = v.id;
        if(priceEl) priceEl.textContent = formatMoney(v.price);
        if(compareWrap){
          if(v.compare_at_price && v.compare_at_price > v.price){
            if(compareEl) compareEl.textContent = formatMoney(v.compare_at_price);
            compareWrap.style.display = '';
          } else {
            compareWrap.style.display = 'none';
          }
        }
        if(addBtn){
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? (addBtn.getAttribute('data-label-available') || 'Add to cart') : (addBtn.getAttribute('data-label-soldout') || 'Sold out');
        }
      }

      optionSelects.forEach(function(sel){
        sel.addEventListener('change', function(){
          applyVariant(findVariant());
        });
      });

      // initial
      applyVariant(findVariant());
    });
  }

  // AJAX add-to-cart (optional)
  function initAjaxAddToCart(){
    $all('form[data-ajax-add]').forEach(function(form){
      form.addEventListener('submit', async function(ev){
        if(!window.fetch) return;
        ev.preventDefault();

        var btn = form.querySelector('button[type="submit"]');
        if(btn){ btn.disabled = true; btn.dataset.prev = btn.textContent; btn.textContent = 'Adding…'; }

        var fd = new FormData(form);
        try{
          var res = await fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body: fd });
          if(!res.ok) throw new Error('Add failed');
          var data = await res.json();

          var notice = form.querySelector('[data-add-notice]');
          if(notice){
            notice.textContent = 'Added to cart ✓';
            notice.style.display = '';
            setTimeout(function(){ notice.style.display='none'; }, 2200);
          }
          // update cart count if present
          var countEl = document.querySelector('[data-cart-count]');
          if(countEl){
            var cartRes = await fetch('/cart.js', { headers:{'Accept':'application/json'}});
            if(cartRes.ok){
              var cart = await cartRes.json();
              countEl.textContent = cart.item_count;
            }
          }
        }catch(e){
          var notice2 = form.querySelector('[data-add-notice]');
          if(notice2){
            notice2.textContent = 'Could not add to cart. Try again.';
            notice2.style.display = '';
            setTimeout(function(){ notice2.style.display='none'; }, 3000);
          } else {
            window.location.href = '/cart';
          }
        }finally{
          if(btn){ btn.disabled = false; btn.textContent = btn.dataset.prev || 'Add to cart'; }
        }
      });
    });
  }

  // Stream Gift checkbox: only show when /healthz is reachable
  function initStreamGiftCheckbox(){
    var wrapSel = '[data-stream-gift-wrap]';
    var cbSel   = '[data-stream-gift-checkbox]';

    var wraps = $all(wrapSel);
    if(!wraps.length) return;

    // Default: hidden + disabled
    wraps.forEach(function(w){
      w.hidden = true;
      var cb = $(cbSel, w);
      if(cb) cb.disabled = true;
    });

    var HEALTHZ_URL = 'https://letsallgame.ngrok.app/healthz';
    var TIMEOUT_MS = 1200;

    // Tiny fetch with timeout (no deps)
    function fetchWithTimeout(url, ms){
      if(!window.fetch) return Promise.reject(new Error('fetch unavailable'));
      var controller = ('AbortController' in window) ? new AbortController() : null;

      var timer = setTimeout(function(){
        try { if(controller) controller.abort(); } catch(e){}
      }, ms);

      var opts = { method:'GET', mode:'cors', cache:'no-store' };
      if(controller) opts.signal = controller.signal;

      return fetch(url, opts).finally(function(){ clearTimeout(timer); });
    }

    fetchWithTimeout(HEALTHZ_URL, TIMEOUT_MS)
      .then(function(res){
        if(!res.ok) throw new Error('healthz not ok');
        return res.json().catch(function(){ return {}; });
      })
      .then(function(data){
        if(!data || data.ok !== true) return;

        // Show + enable
        wraps.forEach(function(w){
          w.hidden = false;
          var cb = $(cbSel, w);
          if(cb) cb.disabled = false;
        });
      })
      .catch(function(_e){
        // Offline: keep hidden. No console spam needed.
      });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initMediaGalleries();   // <-- required for thumbnail click swapping
    initVariantForms();
    initAjaxAddToCart();
    initStreamGiftCheckbox(); // <-- ADD HERE
  });
})();
